document.addEventListener('DOMContentLoaded', function () {

  // Delegate click events on all swatch triggers
  document.addEventListener('click', function (e) {
    const swatchWrapper = e.target.closest('[data-swatch-trigger]');
    if (!swatchWrapper) return;

    // Prevent default link behavior
    e.preventDefault();
    e.stopPropagation();

    const productCard = swatchWrapper.closest('.product-card');
    if (!productCard) return;

    const variantImageUrl = swatchWrapper.getAttribute('data-variant-image');

    // ===== 1. Update Active State =====
    const allSwatches = productCard.querySelectorAll('[data-swatch-trigger]');
    allSwatches.forEach(function (swatch) {
      swatch.classList.remove('is-active');
    });
    swatchWrapper.classList.add('is-active');

    // ===== 2. Swap Image =====
    if (variantImageUrl && variantImageUrl !== '') {
      const mainImageWrapper = productCard.querySelector('.product-card__image--main');
      if (!mainImageWrapper) return;

      const mainImage = mainImageWrapper.querySelector('img');
      if (!mainImage) return;

      // Add loading state
      mainImage.classList.add('is-loading');

      // Create new image to preload
      const newImg = new Image();
      newImg.onload = function () {
        mainImage.src = variantImageUrl;
        mainImage.srcset = '';
        mainImage.classList.remove('is-loading');
      };
      newImg.onerror = function () {
        mainImage.classList.remove('is-loading');
      };
      newImg.src = variantImageUrl;
    }
  });

  // ===== Prevent hover white overlay =====
  document.addEventListener('mouseenter', function (e) {
    const swatchWrapper = e.target.closest('[data-swatch-trigger]');
    if (!swatchWrapper) return;

    const link = swatchWrapper.querySelector('a');
    if (link) {
      link.addEventListener('click', function (ev) {
        ev.preventDefault();
      });
    }
  }, true);
});
